import { Route, NavLink, Redirect, Link } from "react-router-dom"
import about from "../../images/about.png"
import NodeJS from "./NodeJS"
import MongoDB from "./MongoDB"
import Express from "./Express"
import React from "./ReactJS"
import JavaScript from "./JavaScript"
import logoreact from "../../react_logo.png"
import nodejslogo from "../../nodejs_logo.png"
import mongodblogo from "../../mongodblogo.png"
import expresslogo from "../../express_logo.png"
import javascriptlogo from "../../javascript_logo.png"
export default function AboutUs() {
    return (
        <>
            <section className="py-10 px-5 md:mt-20">
                <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:items-center lg:gap-10">
                    <article >
                        <img  src={about} alt=""/>
                    </article>
                    <article >
                        <h1 className="font-bold text-4xl md-5 mb-4 mt-10 md:mt-0">Why dose?</h1>
                        <p>Full responsive mobile web developer using JavaScript, React, Node.js, Express to build front-end architecture, backend data display and user interface conventions that facilitate viewing, searching, and changing information using based
                        forms and reports · Strong manegment Know as CRUD functionality be implemented with document database, object database or text · Google/jwt Authorizations Middleware. · Scalable for high-traffic pages. · Technologies: HTML5, CSS3,
                        Javascript, Matireal-ui, React, Node.js,Express, Heroku, MongoDB Git.</p>
                    </article>
                </div>
            </section>
            <article className="container py-7">
                <h2 className="text-center mt-5 pb-5 font-bold text-4xl ">Technological capabilities</h2>
                <div  >
                <NavLink  to="/about-us/nodejs" style={{ display: "inline-flex", margin: 5, padding: 5  }}  >
                    <article >
                        <img  src={nodejslogo} alt=""/>
                        <span className="badge bg-secondary">NodeJS</span>
                    </article>
                </NavLink>
                <NavLink to="/about-us/mongodb" style={{ display: "inline-flex", margin: 5, padding: 5  }} >
                    <article >
                        <img  src={mongodblogo} alt=""/>
                        <span className="badge bg-secondary">MongoDB</span>
                    </article>
                </NavLink>
                <NavLink to="/about-us/express" style={{ display: "inline-flex",  overflow: "hidden", margin: 5, padding: 5  }} >
                    <article >
                        <img  src={expresslogo} alt=""/>
                        <span className="badge bg-secondary">Express</span>
                    </article>
                </NavLink>
                <NavLink to="/about-us/react" style={{ display: "inline-flex", margin: 5, padding: 5  }}  >
                    <article >
                        <img  src={logoreact} alt=""/>
                        <span className="badge bg-secondary">ReactNative</span>
                    </article>
                </NavLink>
                <NavLink to="/about-us/javascript" style={{ display: "inline-flex", overflow: "hidden", margin: 5, padding: 5  }} >
                    <article >
                        <img  src={javascriptlogo} alt=""/>
                        <span className="badge bg-secondary">JavaScript</span>
                    </article>
                </NavLink>
                {/* <p>
                    <button className="btn btn-primary" type="button" data-bs-toggle="collapse" data-bs-target="#collapseWidthExample" aria-expanded="false" aria-controls="collapseWidthExample">
                        Toggle width collapse
                    </button>
                </p>
                <div style={{minHeight: 120 }}>
                    <div className="collapse collapse-horizontal" id="collapseWidthExample">
                        <div className="card card-body" style={{width: 300}}>
                            This is some placeholder content for a horizontal collapse. It's hidden by default and shown when triggered.
                        </div>
                    </div>
                </div> */}
                </div>
                <Redirect to="/about-us/nodejs" />
                <Route path="/about-us/nodejs" render={() => <NodeJS /> } />
                <Route path="/about-us/mongodb" render={() => <MongoDB /> } />
                <Route path="/about-us/express" render={() => <Express /> } />
                <Route path="/about-us/react" render={() => <React /> } />
                <Route path="/about-us/javascript" render={() => <JavaScript /> } />
            </article>
        </>
    )
}
